// @flow

export { default } from './DayAvailabilityMultiSpec';
